import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { errorSideEffects, successSideEffects, updatingSideEffects } from "..";
import { toastGetError, Toastify } from "../../../components/Toaster";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../services/analytics/tracking";

export interface WorkflowMutationState extends MutationTrackingState {
  Data?: any;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

const initialState: WorkflowMutationState = {
  Data: null,
  isUpdating: false,
  isSuccess: false,
  isError: false,
  errorMessage: null
};

const workflowMutationSlice = createSlice({
  name: "workflowMutations",
  initialState,
  reducers: {
    workflowMutationRequest(state, action: PayloadAction<any>) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    workflowMutationSuccess(state, action: PayloadAction<any>) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state, "success"));
      state.Data = action.payload;
      Toastify("success", "Workflow updated successfully.");
    },
    workflowMutationError(state, action: PayloadAction<string>) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state, "error"));
      state.errorMessage = action.payload;
      toastGetError(action.payload);
    }
  }
});

export const { workflowMutationRequest, workflowMutationSuccess, workflowMutationError } = workflowMutationSlice.actions;

export default workflowMutationSlice.reducer;
